import http from '@axios'
import paramsConverter from './utils/paramsConverter'

const resource = '/api/v1/mutation'

export default {
  list(params = {}) {
    const paramsString = paramsConverter(params)

    return http.get(`${resource}${paramsString}`)
  },
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
  update(mutation, uuid) {
    return http.post(`${resource}/${uuid}?_method=PUT`, mutation)
  },
  add(mutation) {
    return http.post(`${resource}`, mutation)
  },
  destroy(uuid) {
    return http.delete(`${resource}/${uuid}`)
  },
}
